import React from 'react';

import { Anchor, Box, Container, Flex } from 'ui';
import { PoweredByGivebacks } from 'ui/Icons';

import { useBreakPoints } from '../../../hooks';
import './onboardingLayout_styles.scss';

type Props = {
  leftSideContent?: React.ReactChild[] | React.ReactNode;
  children: React.ReactChild[] | React.ReactNode;
  layoutRef?: React.Ref<HTMLDivElement>;
  withHeaderSpace?: boolean;
};

// No Business logic. This should be used strictly to create the layout experience for '/donate/:uuid'
export const OnboardingLayout = ({
  leftSideContent,
  children,
  layoutRef,
  withHeaderSpace = false,
}: Props) => {
  const { isDesktop } = useBreakPoints();
  const headerSpaceStyles = {
    overFlow: 'hidden',
    maxHeight: '100vh',
  };

  return (
    <Container
      className="simpleDonations_container"
      fluid
      style={withHeaderSpace ? { headerSpaceStyles } : undefined}
    >
      <Flex w="100%" maw={1190} gap="xl" justify={{ base: 'center', md: 'space-between' }}>
        {isDesktop && (
          <Flex direction="column" maw={487} w="100%" mt="128px">
            {leftSideContent}
            <Anchor href="https://www.givebacks.com/" target="_blank" pos={'absolute'} bottom={45}>
              <PoweredByGivebacks />
            </Anchor>
          </Flex>
        )}
        <Box
          ref={layoutRef}
          w="100%"
          h="100%"
          mah="100vh"
          maw={586}
          mt={{ base: withHeaderSpace ? '80px' : 0, lg: 0 }}
          style={{
            overflow: 'scroll',
            '::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
          py={70}
        >
          {children}
        </Box>
      </Flex>
    </Container>
  );
};
